import { Input, Component, OnInit, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiDataService, IApiResultObject } from './services/api-data.service';
import { FormControl, FormGroup, Validator, Validators } from "@angular/forms"
import { setInterval } from 'timers';
import { error } from '@angular/compiler/src/util';
//declare function showMessageDlg(title: string, body: string, okLabel: string, onOk: any, cancelLabel: string, onCancel: any): any;
declare function ajaxLoaderStart(): any;
declare function ajaxLoaderEnd(): any;
declare function showEnterDialog(): any;

@Component({
    selector: 'registration',
    template: require('./app.component.registration.html'),
    styles: [require('./app.component.registration.css')],
    providers: [ApiDataService]
})
export class AppComponent {
    private returnUrl: string;
    private culture: string = 'uk';

    private passwordType: string = 'password';
    private newPasswordType: string = 'password';
    private contractLink: string;

    private isShowError: boolean = false;   
    private isShowSuccess: boolean = false;
    private errorBirhday: Boolean = false;
    private hide_spam: boolean = true;

    private isResetPasswordEmailError: boolean = false;

    private isLoginValid: boolean = true;
    private result: IApiResultObject = null;
    registrationStep1: FormGroup;
    registrationStep2: FormGroup;
    registrationStep3Private: FormGroup;
    registrationStep3Legal: FormGroup;
    registrationStep4: FormGroup;
    registrationStep5: FormGroup;

    private isStep1: boolean = true;
    private isStep2: boolean = false;
    private isStep3: boolean = false;
    private isStep3Private: boolean = true;
    private isStep3Legal: boolean = false;
    private isStep4: boolean = false;
    private isStep5: boolean = false;
    private isStep6: boolean = false;

    goToStep1(): void {
        this.isStep1 = true;
        this.isStep2 = false;
        this.isStep3 = false;
        this.isStep4 = false;
        this.isChangePassword = false;
        this.isStep5 = false;
        this.isStep6 = false;
    }

    goToStep2(): void {
        this.isStep1 = false;
        this.isStep2 = true;
        this.isStep3 = false;
        this.isStep4 = false;
        this.isStep5 = false;
        this.isStep6 = false;
    }

    goToStep3(): void {
        this.isStep1 = false;
        this.isStep2 = false;
        this.isStep3 = true;
        this.isStep4 = false;
        this.isStep5 = false;
        this.isStep6 = false;
    }

    goToStep4(): void {
        this.isStep1 = false;
        this.isStep2 = false;
        this.isStep3 = false;
        this.isStep4 = true;
        this.isStep5 = false;
        this.isStep6 = false;
    }

    goToStep5(): void {
        this.isStep1 = false;
        this.isStep2 = false;
        this.isStep3 = false;
        this.isStep4 = false;
        this.isStep5 = true;
        this.isStep6 = false;
    }

    goToStep6(): void {
        this.isStep1 = false;
        this.isStep2 = false;
        this.isStep3 = false;
        this.isStep4 = false;
        this.isStep5 = false;
        this.isStep6 = true;
    }

    private isUserNameEmail: boolean = true;

    private sendCodeResult: IApiResultObject = null;
    private checkCodeResult: IApiResultObject = null;
    private resetPasswordSendCodeResult: IApiResultObject = null;
    private resetPasswordCheckCodeResult: IApiResultObject = null;

    private code: string = "00000";

    private timeLeft: number = 30;
    private secondsLeft = '0:30';

    private isShowCountSmsError: boolean = false;
    private isShowSendSmsTryLaterError: boolean = false;

    private isShowCodeInvalidCountError: boolean = false;
    private isShowCodeInvalidError: boolean = false;
    private isShowCodeTryLaterError: boolean = false;

    private isLoadingResult: boolean = false;

    private phone: string = "";

    private currentCity: any;
    private initialCity: any;

    private canChangeData: boolean = false;

    private isChangePassword: boolean = false;

    constructor(private translate: TranslateService, private apiDataService: ApiDataService, private elementRef: ElementRef) {
        this.culture = this.elementRef.nativeElement.getAttribute('culture');
        this.returnUrl = this.elementRef.nativeElement.getAttribute('returnUrl');
        
        translate.setDefaultLang(this.culture);  
        this.registrationStep1 = new FormGroup({
            "clientType": new FormControl("", Validators.required),
            "phone": new FormControl("", Validators.required),
            "email": new FormControl("", [Validators.required, Validators.email]),
            "password": new FormControl("", [Validators.required, Validators.minLength(6)]),
            "isAgreed": new FormControl("", null),
            "recaptchaReactive": new FormControl("", null)
        });
        this.registrationStep1.get('clientType').setValue('false');
        this.registrationStep1.get('isAgreed').setValue(false);

        this.registrationStep2 = new FormGroup({
        });

        this.registrationStep3Private = new FormGroup({
            "lastName": new FormControl("", [Validators.required, Validators.pattern("^[!?-_,.а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'0-9\\s-]+$")]),
            "firstName": new FormControl("", [Validators.required, Validators.pattern("^[!?-_,.а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'0-9\\s-]+$")]),
            "middleName": new FormControl("", [Validators.required, Validators.pattern("^[!?-_,.а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'0-9\\s-]+$")]),
            "birthday": new FormControl("", [Validators.required, Validators.pattern("^[!?-_,.а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'0-9\\s-]+$")])
        });

        this.registrationStep3Legal = new FormGroup({
            "companyName": new FormControl("", [Validators.required, , Validators.pattern("^[!?-_,.\"а-щА-ЩЬьЮюЯяЇїІіЄєҐґ'0-9\\s-]+$")]),
            "egrpou": new FormControl("", [Validators.required, Validators.pattern("[0-9]{8}([0-9]{2})?$")])
        });

        this.registrationStep4 = new FormGroup({
        });

        this.onChangeSearch(null);

        this.registrationStep5 = new FormGroup({
            "password": new FormControl("", [Validators.required, Validators.minLength(6)])
        });

        this.contractLink = "https://www.delivery-auto.com/" + this.culture + "/Document/Contract";
    }

    get lastName() { return this.registrationStep3Private.get('lastName'); }
    get firstName() { return this.registrationStep3Private.get('firstName'); }
    get middleName() { return this.registrationStep3Private.get('middleName'); }
    get birthday() { return this.registrationStep3Private.get('birthday'); }
    get companyName() { return this.registrationStep3Private.get('companyName'); }
    get egrpou() { return this.registrationStep3Private.get('egrpou'); }

    ngOnInit(): void {
        
    }

    showEnterDlg(): void {
        showEnterDialog();
    }

    recaptchaStr = '';


    onStep1Click(captchaRef: any): void {
        this.registrationStep1Submit("111111111");
        return;
        if (this.recaptchaStr) {
            captchaRef.reset();
        }
        captchaRef.execute();
    }

    public resolved(captchaResponse: string): void {
        this.recaptchaStr = captchaResponse;
        if (this.recaptchaStr) {
            this.registrationStep1Submit(this.recaptchaStr);
        }
    }

    private keyword: string = 'name';
    private cities: any[] = [];

    selectEvent(item: any): void {
        this.currentCity = item;
    }

    onChangeSearch(val: string): void {
        this.isLoadingResult = true;

        this.apiDataService.GetAnonymous("https://www.delivery-auto.com/api/v4/Public/GetRegistrationCitiesList?culture=" + this.culture + (val == null ? "" : "&search="+val))
            .subscribe(d => {
                let citiesResult = d as IApiResultObject;
                if (citiesResult.status == true) {
                    this.cities = citiesResult.data;
                }
                this.isLoadingResult = false;
            });
    }

    onCleared(e: any): void {
        this.onChangeSearch(null);
        this.currentCity = {};
    }
    
    startTimer(): void {
        this.timeLeft = 30;
        this.secondsLeft = "0:30";
        this.interval();
    }

    interval(): void {
        setTimeout(() => {
            this.timeLeft--;
            let tostr = (number: number) => (number <= 9 ? "0:0" + number.toString() : "0:" + number.toString());
            this.secondsLeft = tostr(this.timeLeft);
            if (this.timeLeft > 0) {
                this.interval();
            }
        }, 1000);
    }
    

    onShowPasswordClick() : void {
        if (this.passwordType === 'password')
            this.passwordType = 'text';
        else
            this.passwordType = 'password';
    }

    onShowNewPasswordClick(): void {
        if (this.newPasswordType === 'password')
            this.newPasswordType = 'text';
        else
            this.newPasswordType = 'password';
    }

    onBirthdayBlur(): void {
        let birthdayText: String;
        birthdayText = this.registrationStep3Private.value.birthday;
        if (birthdayText == null || birthdayText.length != 8)
            this.errorBirhday = true;
        else {
            let day = parseInt(birthdayText.substring(0, 2));
            let month = parseInt(birthdayText.substring(2, 4));
            let year = parseInt(birthdayText.substring(4));
            let currentYear = (new Date()).getFullYear();
            this.errorBirhday = day > 31 || day < 1 || month > 12 || month < 1 || year < 1900 || year > currentYear;

            if (!this.errorBirhday) {
                if (day == 31) {
                    let shortMonth: number[] = [4, 6, 9, 11];
                    this.errorBirhday = shortMonth.includes(month);
                }
                if (month == 2 && day > 28) {
                    if (this.leapYear(year)) {
                        if (day > 29)
                            this.errorBirhday = true;
                    }
                    else
                        this.errorBirhday = true;
                }
            }
        }
        console.log(this.errorBirhday);
        console.log(this.registrationStep3Private.invalid);
        console.log(this.registrationStep3Legal.invalid);
    }

    leapYear(year: number): boolean {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }

    codeChange(code: string): void {
        this.code = code;
    }

    registrationStep1Submit(token: string): void {
        let data = {
            ...this.registrationStep1.value,
            type: "sms",
            recaptchaResponse: token
        };
        ajaxLoaderStart();
        this.apiDataService.PostAnonymous("https://www.delivery-auto.com/api/v4/Public/RegistrationSendValidationCode", data)
            .subscribe(d => {
                ajaxLoaderEnd();
                this.sendCodeResult = d as IApiResultObject;
                if (this.sendCodeResult.status == true) {
                    this.startTimer();
                    if (this.sendCodeResult.data == -1)
                        this.isShowCountSmsError = true;
                    else if (this.sendCodeResult.data == 0)
                        this.isShowSendSmsTryLaterError = true;
                    else {
                        this.goToStep2();
                    }
                }
                else {
                    if (this.sendCodeResult.code == 1) {
                        //reset password
                        this.isChangePassword = true;
                        this.ResetPasswordSendCode();

                    }
                    else if (this.sendCodeResult.code == 2) {
                        //reset password
                        this.isChangePassword = true;
                        this.ResetPasswordSendEmail();
                    }
                    else
                        this.isShowSendSmsTryLaterError = true;
                }
            });
    }

    changeData(): void {
        this.canChangeData = true;
        if (this.registrationStep1.value.clientType == 'false') {
            this.registrationStep3Private.get('lastName').enable();
            this.registrationStep3Private.get('firstName').enable();
            this.registrationStep3Private.get('middleName').enable();
            this.registrationStep3Private.get('birthday').enable();
        }
        else {
            this.registrationStep3Legal.get('companyName').enable();
            this.registrationStep3Legal.get('egrpou').enable();
        }
    }

    registrationStep2Submit(): void {
        ajaxLoaderStart();
        let data = {
            ...this.registrationStep1.value,
            id: this.sendCodeResult.data,
            code: this.code
        };
        this.isShowCodeInvalidCountError = false;
        this.isShowCodeInvalidError = false;
        this.isShowCodeTryLaterError = false;
        this.apiDataService.PostAnonymous("https://www.delivery-auto.com/api/v4/Public/RegistrationGetInfoCheckCode", data)
            .subscribe(d => {
                ajaxLoaderEnd();
                this.checkCodeResult = d as IApiResultObject;
                if (this.checkCodeResult.status == true) {
                    if (this.checkCodeResult.code == 1) {
                        this.goToStep3();
                        if (this.checkCodeResult.data != null) {
                            if (this.registrationStep1.value.clientType == 'false') {
                                this.registrationStep3Private.get('lastName').setValue(this.checkCodeResult.data.lastName);
                                this.registrationStep3Private.get('firstName').setValue(this.checkCodeResult.data.firstName);
                                this.registrationStep3Private.get('middleName').setValue(this.checkCodeResult.data.middleName);
                                this.registrationStep3Private.get('birthday').setValue(this.checkCodeResult.data.birthday);
                                this.registrationStep3Private.get('lastName').disable();
                                this.registrationStep3Private.get('firstName').disable();
                                this.registrationStep3Private.get('middleName').disable();
                                this.registrationStep3Private.get('birthday').disable();
                            }
                            else {
                                this.registrationStep3Legal.get('companyName').setValue(this.checkCodeResult.data.name);
                                this.registrationStep3Legal.get('egrpou').setValue(this.checkCodeResult.data.egrpou);
                                this.registrationStep3Legal.get('companyName').disable();
                                this.registrationStep3Legal.get('egrpou').disable();
                            }
                        }
                        if (this.checkCodeResult.data2 != null) {
                            this.initialCity = { id: this.checkCodeResult.data2.Value, name: this.checkCodeResult.data2.Text };
                        }
                    } else if (this.checkCodeResult.code == -2)
                        this.isShowCodeInvalidCountError = true;
                    else if (this.checkCodeResult.code == 0)
                        this.isShowCodeInvalidError = true;
                    else
                        this.isShowCodeTryLaterError = true;
                    //this.goToSetPassword();
                }
                else {
                    this.isShowCodeTryLaterError = true;
                }
            });
    }

    registrationStep3Submit(): void {
        ajaxLoaderStart();
        let data = {
            ...this.registrationStep1.value,
            ...this.registrationStep3Private.value,
            ...this.registrationStep3Legal.value,
            id: this.sendCodeResult.data,
            code: this.code,
            cityId: this.currentCity.id
        };

        if (data.birthday != null && data.birthday != "" && data.birthday.length >= 8) {
            let day = data.birthday.substring(0, 2);
            let month = data.birthday.substring(2, 4);
            let year = data.birthday.substring(4);
            data.birthday = year + '-' + month + '-' + day;
        }

        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/RegistrationComplete", data)
            .subscribe(d => {
                ajaxLoaderEnd();
                let result: IApiResultObject = d as IApiResultObject;
                if (result.status == true) {
                    this.goToStep4();
                    if (data.clientType === 'true') {
                        this.hide_spam = false;
                    }
                }
                else {
                    this.isShowCodeTryLaterError = true;
                }
            });
    }

    ResetPasswordSendCode(): void {
        let data = {
            phone: this.registrationStep1.value.phone,
        };
        ajaxLoaderStart();
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/ResetPasswordSendCode", data)
            .subscribe(d => {
                ajaxLoaderEnd();
                this.resetPasswordSendCodeResult = d as IApiResultObject;
                if (this.resetPasswordSendCodeResult.status == true) {
                    this.startTimer();
                    if (this.resetPasswordSendCodeResult.data == -1)
                        this.isShowCountSmsError = true;
                    else if (this.resetPasswordSendCodeResult.data == 0)
                        this.isShowSendSmsTryLaterError = true;
                    else
                        this.goToStep2();
                }
                else {
                    this.isShowSendSmsTryLaterError = true;
                }
            });
    }

    ResetPasswordCheckCode(): void {
        let data = {
            id: this.resetPasswordSendCodeResult.data,
            phone: this.registrationStep1.value.phone,
            code: this.code

        };
        this.isShowCodeInvalidCountError = false;
        this.isShowCodeInvalidError = false;
        this.isShowCodeTryLaterError = false;
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/ResetPasswordCheckCode", data)
            .subscribe(d => {
                this.resetPasswordCheckCodeResult = d as IApiResultObject;
                if (this.resetPasswordCheckCodeResult.status == true) {
                    this.goToStep5();
                }
                else {
                    if (this.resetPasswordCheckCodeResult.data == -2)
                        this.isShowCodeInvalidCountError = true;
                    else if (this.resetPasswordCheckCodeResult.data == 0)
                        this.isShowCodeInvalidError = true;
                    else
                        this.isShowCodeTryLaterError = true;
                }
            });
    }

    ResetPasswordSetNew(): void {
        let data = {
            token: this.resetPasswordCheckCodeResult.message,
            password: this.registrationStep5.value.password

        };
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/ResetPasswordSetNew", data)
            .subscribe(d => {
                let result: IApiResultObject = d as IApiResultObject;
                if (result.status == true) {
                    showEnterDialog();
                }
                else {
                    console.log('error reset ' + this.sendCodeResult.data);
                }
            });
    }

    ResetPasswordSendEmail(): void {
        let data = {
            culture: this.culture,
            email: this.registrationStep1.value.email,
        };
        this.apiDataService.Post("https://www.delivery-auto.com/api/v4/Public/PostResetPassword", data)
            .subscribe(d => {
                let result: IApiResultObject = d as IApiResultObject;
                if (result.status == true) {
                    console.log('success reset');
                    this.goToStep6();
                }
                else {
                    this.isResetPasswordEmailError = true;
                }
            });
    }

}